import React from "react";
import { useNavigate } from "react-router-dom";
import { Phone } from "lucide-react";

const CTASection = () => {
  const navigate = useNavigate();

  const sectionStyle = {
    padding: "4rem 0",
    backgroundColor: "#000000",
    color: "white",
    textAlign: "center",
  };

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 1.5rem",
  };

  const titleStyle = {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "1rem",
  };

  const subtitleStyle = {
    fontSize: "1.25rem",
    marginBottom: "2rem",
    color: "#e0e0e0",
  };

  const buttonStyle = {
    background: "linear-gradient(45deg, #0891b2, #22d3ee)",
    color: "white",
    padding: "1rem 2.5rem",
    border: "none",
    borderRadius: "8px",
    fontSize: "1.1rem",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "all 0.3s ease",
    textTransform: "uppercase",
    letterSpacing: "1px",
    verticalAlign: "middle",
  };

  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        <h2 style={titleStyle}>Ready to Improve Your Game?</h2>
        <p style={subtitleStyle}>
          Visit our shop today or contact us for personalized equipment
          recommendations.
        </p>
        <button
          style={buttonStyle}
          onMouseEnter={(e) => {
            e.target.style.transform = "scale(1.05)";
            e.target.style.background =
              "linear-gradient(45deg, #22d3ee, #0891b2)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "scale(1)";
            e.target.style.background =
              "linear-gradient(45deg, #0891b2, #22d3ee)";
          }}
          onClick={() => navigate("/contact")}
        >
          Get Started Today{" "}
          <Phone
            size={18}
            style={{
              marginLeft: "0.1rem",
              display: "inline",
              verticalAlign: "middle",
              paddingBottom: "2px",
            }}
          />
        </button>
      </div>
    </section>
  );
};

export default CTASection;
